import { createContext, useContext, useState } from "react";
import { MessageCircle, MapPin } from "lucide-react";
import { STORES } from "../lib/site";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const Ctx = createContext({ openPicker: () => {} });
export const useWhatsApp = () => useContext(Ctx);

const buildWa = (store, context) => {
  const msg = context
    ? `Ciao ${store.person}! Sono interessato a: ${context}. Potete darmi informazioni?`
    : `Ciao ${store.person}! Vorrei una consulenza gratuita.`;
  return `https://wa.me/${store.whatsapp}?text=${encodeURIComponent(msg)}`;
};

export const WhatsAppProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState(null);
  const openPicker = (ctx = null) => { setContext(ctx); setOpen(true); };

  return (
    <Ctx.Provider value={{ openPicker }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="store-picker-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Scegli il negozio</DialogTitle>
            <DialogDescription>
              {context
                ? `Scrivi direttamente al referente del negozio per: ${context}`
                : "Scrivi direttamente al referente del negozio più comodo per te."}
            </DialogDescription>
          </DialogHeader>
          <div className="mt-2 space-y-3">
            {STORES.map((s) => (
              <a
                key={s.id}
                href={buildWa(s, context)}
                target="_blank"
                rel="noreferrer"
                data-testid={`store-picker-${s.id}`}
                onClick={() => setOpen(false)}
                className="group flex items-center gap-4 rounded-2xl border border-neutral-200 p-4 hover:border-brand hover:bg-brand-soft transition-colors"
              >
                <span className="w-11 h-11 rounded-full bg-[#25D366] text-white flex items-center justify-center shrink-0">
                  <MessageCircle className="w-5 h-5" />
                </span>
                <span className="min-w-0">
                  <span className="block font-display font-bold text-ink">{s.person}</span>
                  <span className="flex items-center gap-1 text-sm text-neutral-500">
                    <MapPin className="w-3.5 h-3.5 text-brand shrink-0" /> {s.address}
                  </span>
                </span>
              </a>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
};
